import { render, staticRenderFns } from "./StatutoryIntro.vue?vue&type=template&id=83eb8706&scoped=true"
import script from "./StatutoryIntro.vue?vue&type=script&lang=js"
export * from "./StatutoryIntro.vue?vue&type=script&lang=js"
import style0 from "./StatutoryIntro.vue?vue&type=style&index=0&id=83eb8706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83eb8706",
  null
  
)

export default component.exports